const constants = {
  TEXT_EDITOR_VERSION: '2.28.2',
};

export default constants;
